export enum meetingDialogAction {
  readonly = "readonly",
  create = "create",
  publish = "publish",
  edit = "edit",
}

export const meetingDialogInputClassName =
  "hover:bg-gray-100 rounded text-sm px-2 py-1.5 focus:outline-0 focus:ring-0";
